export default function initializeApp() {
  $('[data-rel="tooltip"]').tooltip({});
  $('[data-toggle="popover"]').popover({});
}
